import { IStyles } from '../models/app/IStyles';

export const STYLES: IStyles = {
	components: {
		app: {
			children: {
				wrapper: {
					overrides: [
						{
							selector: '[data-selector="base-card-title"]',
							style: {
								font: {
									size: '32px',
									weight: 'normal',
								},
							},
						},
					],
				},
			},
		},
	},
	theme: {
		base: {
			application: {
				font: {
					family: 'Arial',
				},
			},
			card: {
				children: {
					header: {
						text: {
							align: 'center',
						},
					},
					title: {
						display: 'inline-block',
						color: '#4A4A4A',
						lineHeight: '26px',
						width: '230px',
						text: {
							align: 'center',
							transform: 'uppercase',
						},
						border: {
							bottom: {
								width: '1px',
								color: '#C02626',
								style: 'solid',
							},
						},
						padding: {
							bottom: '18px',
						},
					},
					subtitle: {
						color: '#9B9B9B',
						lineHeight: '15px',
						font: {
							size: '12px',
							weight: 'normal',
						},
						margin: {
							_value: '0',
						},
					},
				},
			},
			carousel: {
				children: {
					content: {
						display: 'flex',
					},
					navWrapper: {
						position: 'absolute',

						padding: {
							_value: '4px',
						},
						margin: {
							top: '65px',
						},
						width: '30px',
						height: '30px',
						text: {
							align: 'center',
						},
						border: {
							_value: 'none',
						},
						background: {
							_value: 'none',
						},
					},
					navLeft: {
						left: '0px',
					},
					navRight: {
						right: '0px',
					},
					componentWrapper: {
						transition: {
							_value: 'all 300ms ease-in-out',
						},
						text: {
							align: 'center',
						},
					},
					dot: {
						width: '16px',
						height: '16px',
						background: {
							color: '#DDDDDD',
						},
						border: {
							radius: '50%',
						},
						conditionals: [
							{
								conditional: {
									conditions: [
										{
											field: 'selected',
											operator: '=',
											value: true,
										},
									],
								},
								style: {
									background: {
										color: 'blue',
									},
								},
							},
						],
					},
					dotWrapper: {
						padding: {
							left: '10px',
							right: '10px',
						},
					},
					dots: {
						display: 'flex',
						justifyContent: 'center',
					},
				},
				overrides: [
					{
						selector: '[data-selector="base-carousel-navWrapper"]:nth-child(3)',
						style: {
							right: '0px',
						},
					},
				],
			},
		},
		overview: {
			award: {
				children: {
					wrapper: {
						max: {
							width: '335px',
						},
						padding: {
							_value: '15px',
						},
						box: {
							shadow: '0 2px 4px 0 rgba(0,0,0,0.2);',
						},
						margin: {
							_value: '8px',
						},
					},
					imageWrapper: {
						text: {
							align: 'center',
						},
					},
					awardImage: {
						max: {
							width: '303px',
							height: '122px',
						},
					},
					name: {
						lineHeight: '13px',
						font: {
							size: '14px',
							weight: 'bold',
						},
						margin: {
							top: '25px',
						},
					},
					description: {
						color: '#707173',
						lineHeight: '16px',
						font: {
							size: '14px',
						},
					},
				},
			},
			awards: {
				children: {
					wrapper: {
						overrides: [
							{
								selector: '[data-selector="base-carousel-content"]',
								style: {
									height: '300px',
								},
							},
							{
								selector: '[data-selector="base-carousel-dots"]',
								style: {
									display: 'none',
								},
							},
							{
								selector: '[data-selector="overview-award-wrapper"]',
								style: {
									text: {
										align: 'left',
									},
								},
							},
						],
					},
					awardWrapper: {
						display: 'inline-block',
					},
				},
			},
			disclaimers: {
				lineHeight: '18px',
				font: {
					size: '14px',
				},
			},
		},
	},
};